<template>
    <section
        class="button-group-image"
        :style="{...generateStylingVariables(content.style)}"
    >
        <div class="button-group-image__inner container">
            <zoe-atom-text
                v-if="stringIsNotEmpty(content.text.value)"
                class="button-group-image__text"
                :item="content.text.value"
            />

            <div class="button-group-image__options">
                <div
                    v-for="(item, index) in content.items"
                    :key="index"
                    class="button-group-image__option"
                    @click="buttonClick"
                >
                    <zoe-atom-media
                        class="button-group-image__image"
                        :item="item.media.value"
                    />

                    <zoe-atom-text
                        class="button-group-image__label"
                        :item="item.text.value"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ZoeAtomMedia from '../../../../../../resources/components/atoms/media/v1.0.0/zoe-atom-media.vue';
import ZoeAtomText from '../../../../../../resources/components/atoms/text/v1.0.0/zoe-atom-text.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';
import scrollToSelector from '../../../../../../resources/mixins/utils/scroll-to-selector';
import { generateStylingVariables } from '../../../../../../resources/mixins/styling/styling';

export default {
    components: { ZoeAtomText, ZoeAtomMedia },
    mixins: [ Component ],

    methods: {
        generateStylingVariables,
        buttonClick() {
            const scrollOffset = this.getValue('general.logobar.position') === 'fixed' ? -160 : -60;

            scrollToSelector('.step__flow', scrollOffset);
        },
    },
};
</script>

<style lang="scss" scoped>
@use 'step-button-group-image';

.button-group-image {
    --background: v-bind('content.style.background.value');
    --item-background: v-bind('content.style.itemBackground.value');
    --column-count-mobile: v-bind('content.columnCountOnMobile.value');
    --column-count-desktop: v-bind('content.buttonsOnRow.value');
}
</style>
